//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx' // import xlsx
import {
  GChart
} from 'vue-google-charts'

import '@/mixins/global'
import axios, {
  CancelToken
} from 'axios'
export default {
  components: {
    GChart
  },
  data () {
    return {
      pagename: 'page02',
      input_expoet: [{
        lable: 'G1',
        status: true,
        location: 'NYG'
      },
      {
        lable: 'G2',
        status: true,
        location: 'NYG'
      },
      {
        lable: 'G3',
        status: true,
        location: 'NYG'
      },
      {
        lable: 'G4',
        status: true,
        location: 'NYG'
      },
      {
        lable: 'TRM',
        status: true,
        location: 'TRM'
      },
      {
        lable: 'VN1',
        status: true,
        location: 'VN'
      },
      {
        lable: 'VN1',
        status: true,
        location: 'VN'
      }
      ],
      model_machine: 'ALL',
      options_machine: [{
        label: 'ALL',
        value: 'ALL'
      },
      {
        label: 'AUTO',
        value: 'AUTO'
      },
      {
        label: 'BULK',
        value: 'BULK'
      }
      ],
      exportExcel: false,
      visible: true,
      filter: '',
      datadetail: [],
      dataoutput: [],
      dataoutput2: [],
      dataoutput3: [],
      date: '',
      location: 'G1',
      locations: ['G1', 'G2', 'G3', 'G4', 'TRM', 'VN1', 'VN2'],
      department: 'ALL',
      sql1: '',
      sql2: '',
      initialPagination: {
        sortBy: 'QUEUE_NO',
        descending: false,
        page: 1,
        rowsPerPage: 20
        // rowsNumber: xx if getting data from a server
      },
      cut: '',
      plan: '',
      percent: 0,
      columns_detail: [{
        field: 'QUEUE_NO',
        name: 'QUEUE_NO',
        label: 'Queue',
        align: 'center',
        sortable: true
      },
      {
        field: 'PLAN_TABLE',
        name: 'PLAN_TABLE',
        label: 'Plan table',
        align: 'center',
        sortable: true
      },
      {
        field: 'GROUP_MC',
        name: 'GROUP_MC',
        label: 'Group',
        align: 'center',
        sortable: true
      },
      // {
      //   field: "MC_TYPE",
      //   name: "MC_TYPE",
      //   label: "MC Type.",
      //   align: "center",
      //   sortable: true
      // },
      {
        field: 'TABLE_GM',
        name: 'TABLE_GM',
        label: 'Table',
        align: 'center',
        sortable: true
      },
      {
        field: 'SO_NO',
        name: 'SO_NO',
        label: 'SO No.',
        align: 'right',
        sortable: true
      },
      {
        field: 'GMT',
        name: 'GMT',
        label: 'Product',
        align: 'center',
        sortable: true
      },
      {
        field: 'STYLE_REF',
        name: 'STYLE_REF',
        label: 'Style',
        align: 'left',
        sortable: true
      },
      {
        field: 'SUB_PROCESS',
        name: 'SUB_PROCESS',
        label: 'Sub-Process',
        align: 'center',
        sortable: true
      },
      {
        field: 'FABRIC_TYPE',
        name: 'FABRIC_TYPE',
        label: 'Fabric',
        align: 'left',
        sortable: true
      },
      {
        field: 'GM_NO',
        name: 'GM_NO',
        label: 'GM-08',
        align: 'left',
        sortable: true
      },
      {
        field: 'PART_NO',
        name: 'PART_NO',
        label: 'Part',
        align: 'center',
        sortable: true
      },
      {
        field: 'RATIO',
        name: 'RATIO',
        label: 'Ratio',
        align: 'right',
        sortable: true
      },
      {
        field: 'PERI',
        name: 'PERI',
        label: 'Peri.',
        align: 'right',
        sortable: true
      },
      {
        field: 'PLY',
        name: 'PLY',
        label: 'Ply',
        align: 'right',
        sortable: true
      },
      {
        field: 'TOTAL_PCS',
        name: 'TOTAL_PCS',
        label: 'Total PCs.',
        align: 'right',
        sortable: true
      },
      {
        field: 'MARK_LENGTH',
        name: 'MARK_LENGTH',
        label: 'Maker length',
        align: 'right',
        sortable: true
      }
      ],
      chartData: [],
      chartOptions: {
        backgroundColor: {
          fill: '#ffffff',
          fillOpacity: 0.5
        },
        title: null,
        fontSize: 12,
        fontName: 'Tahoma',
        legend: {
          position: 'none'
        },
        colors: ['red', 'green'],
        bar: {
          groupWidth: '80%'
        },
        vAxis: {
          minValue: 0,
          maxValue: 10,
          gridlines: {
            count: 0
          }
          //   minorGridlines: {
          //     count: 0,
          //   },
        },
        animation: {
          duration: 1200,
          easing: 'out',
          startup: true
        },
        annotations: {
          textStyle: {
            fontName: 'Times-Roman',
            fontSize: 18,
            bold: true,
            italic: true,
            color: '#871b47'
          }
        }
      },
      jsonxx: [{
        name: 'Dady',
        age: '21'
      },
      {
        name: 'Jonh',
        age: '25'
      },
      {
        name: 'James',
        age: '17'
      }
      ]
    }
  },
  created () {
    // this.CheckLocal();
    // this.LoadFirst();
    // this.windowHeight = window.innerHeight;
    // this.windowWidth = window.innerWidth;
  },
  async mounted () {
    await this.getloc()
    await this.curdate()

    this.pulling = setTimeout(() => {
      this.pullData()
      this.LoadDataAll()
    }, 1500)

    // let time = await this.gettime();
    // console.log(time);
    // window.addEventListener("resize", () => {
    //   this.windowHeight = window.innerHeight;
    //   this.windowWidth = window.innerWidth;
    //   this.resize();
    // });
  },
  watch: {
    // date: function(newValue, oldValue) {
    // }
  },
  methods: {
    onExport () {
      const dataWS = XLSX.utils.json_to_sheet(this.jsonxx)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'export.xlsx')
    },
    async load_export () {
      this.visible = true
      console.log('export xxx')
      console.log(this.input_expoet)
      await axios({
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/export',
        data: JSON.stringify(this.input_expoet)
      }).then(res => {
        console.log('export zzz')
        console.log(res.data)
      })
    },
    keeplocation () {
      this.keeploc(this.pagename, this.location)
      this.LoadDataAll()
    },
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (
          currentdate.getMinutes() % 5 == 0 &&
                    currentdate.getSeconds() == 0
        ) {}
        // console.log(currentdate)
      }, 1000)
    },
    async getloc () {
      // eslint-disable-next-line no-debugger

      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename
        }
      }
      let res = await axios.post(`${this.$apiflask}/log/getloc`, postjson)
      this.location = res.data.loc
      // console.log(res.data);
    },
    async curdate () {
      let res = await axios.post(`${this.$apiflask}/curdate`)
      this.date = res.data.dte
      // console.log(res.data);
    },
    async loaddetail () {
      let time = await this.gettime()
      this.visible = true
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        filter: {
          loc: this.location,
          mctype: this.department,
          cutdate: this.date,
          time: time
        }
      }
      console.log('part1')
      console.log(postjson)
      // `${this.$apiflask}/api/board2/detail`
      /* let res = await axios.post(
                    'http://127.0.0.1:9000/nygcontrolroom/api/cut_plan_new.php/detail',
                    postjson
                  ); */

      axios({
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/detail',
        data: JSON.stringify(postjson)
      }).then(res => {
        console.log('dsdata')
        console.log(res.data)
        // eslint-disable-next-line no-debugger
        this.datadetail = res.data.dsdata
        console.log(this.datadetail)
        /* this.datadetail = res.data.dsdata.sort(function (a, b) {
                          return parseInt(a.QUEUE_NO) - parseInt(b.QUEUE_NO)
                        }) */
        this.cut = res.data.cut
        this.plan = res.data.plan
        if (isNaN((res.data.cut * 100) / res.data.plan)) {
          this.percent = 0
        } else {
          this.percent = parseFloat(((res.data.cut * 100) / res.data.plan).toFixed(2))
        }
        console.log(this.cut)
        console.log(this.plan)
        console.log(this.percent)

        // this.percent = parseFloat(res.data.percent)
      })

      // this.sql1 = res.data.sql;
      /* console.log('Load Detail');
                  console.log(res.data); */
    },
    async loadoutput () {
      let time = await this.gettime()
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        filter: {
          loc: this.location,
          mctype: this.department,
          cutdate: this.date,
          time: time
        }
      }
      console.log('part2')
      console.log(postjson)

      axios({
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/output1',
        data: JSON.stringify(postjson)
      }).then(res => {
        console.log('dataoutput1')
        console.log(res.data)
        this.dataoutput = res.data.dsdata
      })
      // this.sql2 = res.data.sql;
    },
    async loadoutput2 () {
      let time = await this.gettime()
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        filter: {
          loc: this.location,
          mctype: this.department,
          cutdate: this.date,
          time: time
        }
      }
      console.log('part3')
      console.log(postjson)
      axios({
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/output2',
        data: JSON.stringify(postjson)
      }).then(res => {
        console.log('dataoutput2')
        console.log(res.data)
        // eslint-disable-next-line no-debugger
        this.dataoutput2 = res.data.dsdata

        let TOTAL_AUTO = 0
        let COUNT_AUTO = 0
        let PER_TOTAL_AUTO = '0%'
        let PER_ACTUAL_AUTO = '0%'
        let TOTAL_BULK = 0
        let COUNT_BULK = 0
        let PER_TOTAL_BULK = '0%'
        let PER_ACTUAL_BULK = '0%'
        // res.data.DataRows
        if (res.data.DataRows.length > 0) {
          res.data.DataRows.forEach(e => {
            if (e.MC_TYPE == 'AUTO') {
              try {
                TOTAL_AUTO = parseInt(res.data.DataRows[0]['TOTLA_COUNT'])
              } catch (err) {
                TOTAL_AUTO = 0
              }
              try {
                COUNT_AUTO = parseInt(res.data.DataRows[0]['COUNT_ACTUAL'])
              } catch (err) {
                COUNT_AUTO = 0
              }
              try {
                PER_TOTAL_AUTO = res.data.DataRows[0]['PERCENTOTAL']
              } catch (err) {
                TOTAL_AUTO = '0%'
              }
              try {
                PER_ACTUAL_AUTO = res.data.DataRows[0]['PERCENACTUAL']
              } catch (err) {
                TOTAL_AUTO = '0%'
              }
            } else {
              try {
                TOTAL_BULK = parseInt(res.data.DataRows[1]['TOTLA_COUNT'])
              } catch (err) {
                TOTAL_BULK = 0
              }
              try {
                COUNT_BULK = parseInt(res.data.DataRows[1]['COUNT_ACTUAL'])
              } catch (err) {
                COUNT_BULK = 0
              }
              try {
                PER_TOTAL_BULK = res.data.DataRows[1]['PERCENTOTAL']
              } catch (err) {
                TOTAL_AUTO = '0%'
              }
              try {
                PER_ACTUAL_BULK = res.data.DataRows[1]['PERCENACTUAL']
              } catch (err) {
                TOTAL_AUTO = '0%'
              }
            }
          })
        }

        // this.chartData = res.data.chartData
        // eslint-disable-next-line camelcase
        var data_test = []
        // eslint-disable-next-line standard/object-curly-even-spacing
        data_test[0] = ['TYPE', 'TOTAL', {
          'role': 'style'
        }, {
          'role': 'annotation'
        }, 'ACTUAL', {
          'role': 'style'
        }, {
          'role': 'annotation'
        }]

        data_test[1] = ['AUTO', TOTAL_AUTO, '#3498DB', PER_TOTAL_AUTO, COUNT_AUTO, '#f39c12', PER_ACTUAL_AUTO]
        data_test[2] = ['BULK', TOTAL_BULK, '#3498DB', PER_TOTAL_BULK, COUNT_BULK, '#f39c12', PER_ACTUAL_BULK]
        /* data_test[1] = res.data.chartData[1]
                        data_test[2] = res.data.chartData[2] */
        // eslint-disable-next-line no-unused-expressions
        /* data_test[1] = ['AUTO', parseInt(res.data.chartData[2][1]), '#3498DB', res.data.chartData[1][3], parseInt(res.data.chartData[2][4]), '#f39c12', res.data.chartData[2][6]]
                data_test[2] = ['BULK', parseInt(res.data.chartData[1][1]), '#3498DB', res.data.chartData[2][3], parseInt(res.data.chartData[1][4]), '#f39c12', res.data.chartData[1][6]] */
        /* data_test[0][0] = 'TYPE'
                        data_test[0][1] = 'TOTAL'
                        data_test[0][2] = { 'role': 'style' }
                        data_test[0][3] = { 'role': 'annotation' }
                        data_test[0][4] = 'ACTUAL'
                        data_test[0][5] = { 'role': 'style' }
                        data_test[0][6] = { 'role': 'annotation' } */
        console.log(data_test)
        console.log(res.data.chartData)
        // eslint-disable-next-line camelcase
        this.chartData = data_test
        this.visible = false
      })
    },
    async loadoutput3 () {
      let time = await this.gettime()
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        filter: {
          loc: this.location,
          mctype: this.department,
          cutdate: this.date,
          time: time
        }
      }
      console.log('part4')
      console.log(postjson)
      axios({
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/output3',
        data: JSON.stringify(postjson)
      }).then(res => {
        console.log('dataoutput3')
        console.log(res.data)
        this.dataoutput3 = res.data.dsdata
      })
    },
    async LoadDataAll () {
      this.$refs.qDateProxy.hide()
      this.dataoutput2 = []
      this.percent = 0
      this.visible = true
      let detail = await this.loaddetail()
      let output = await this.loadoutput()
      let output2 = await this.loadoutput2()
      // let output3 = await this.loadoutput3();
    },
    gm08 (val) {
      return val.substring(7, 11)
    },
    grpnew (val1, val2) {
      // console.log(val2)
      try {
        if (val2 == null) {
          // console.log(val1.substring(0, 1) + "-" + "N/A")
          return val1.substring(0, 1) + '-' + 'N/A'
        }
        // console.log(val1.substring(0, 1) + "-" + val2.substring(4, 5))
        return val1.substring(0, 1) + '-' + val2.substring(4, 5)
      } catch (err) {
        return ''
      }
    },
    openCutSpeed () {
      let routeData = this.$router.resolve({
        name: 'CutSpeed'
      })
      window.open(routeData.href, 'openCutSpeed')
    },
    openDailyCut () {
      let routeData = this.$router.resolve({
        name: 'DailyCut',
        params: {
          loc: this.location
        }
      })
      window.open(routeData.href, 'openDailyCut')
    }
  }
}
